import {BaseContainerModel} from '../base-container.model';
import {bl_applet_notification_template_exts_RowClass, bl_applet_notification_template_hdr_RowClass} from '../../dbschema';

export class AppletNotificationTemplateContainerModel extends BaseContainerModel {
  bl_applet_notification_template_hdr: bl_applet_notification_template_hdr_RowClass = new bl_applet_notification_template_hdr_RowClass();
  bl_applet_notification_template_exts: bl_applet_notification_template_exts_RowClass[] = [];
}
